// components/mypage/MyPageNav.tsx
import { Link, useLocation } from "react-router-dom";

interface NavItem {
  label: string;
  href: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: "내 정보", href: "/mypage" },
  { label: "마루 포인트 내역", href: "/mypage/point" },
  { label: "출석현황", href: "/mypage/attendance" },
];

interface MyPageNavProps {
  variant?: "sidebar" | "tabs";
}

export default function MyPageNav({ variant = "sidebar" }: MyPageNavProps) {
  const { pathname } = useLocation();

  const isActive = (href: string) =>
    href === "/mypage"
      ? pathname === "/mypage" || pathname === "/mypage/edit"
      : pathname === href;

  if (variant === "tabs") {
    return (
      <nav className="bg-white border-b border-[#f0ebe7]">
        <div className="flex overflow-x-auto">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={[
                "shrink-0 px-5 py-3 text-[14px] font-medium no-underline border-b-2 transition-colors duration-150 whitespace-nowrap",
                isActive(item.href)
                  ? "border-[#887267] text-[#887267] font-bold"
                  : "border-transparent text-[#555] hover:text-[#887267]",
              ].join(" ")}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </nav>
    );
  }

  return (
    <aside className="w-[220px] shrink-0">
      <div className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_12px_rgba(136,114,103,0.08)] border border-[#f0ebe7]">
        <div className="bg-[#887267] px-5 py-4">
          <p className="m-0 text-white/70 text-[12px] font-medium tracking-wide uppercase">My Page</p>
          <p className="m-0 text-white text-[16px] font-bold mt-[2px]">마이페이지</p>
        </div>

        <nav className="py-2">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={[
                "flex items-center gap-3 px-5 py-[11px] text-[14px] no-underline transition-all duration-150 group",
                isActive(item.href)
                  ? "text-[#887267] font-bold bg-[#fdf7f0]"
                  : "text-[#555] font-medium hover:text-[#887267] hover:bg-[#fdf7f0]",
              ].join(" ")}
            >
              <span
                className={[
                  "w-[3px] h-[18px] rounded-full transition-all duration-150 shrink-0",
                  isActive(item.href) ? "bg-[#f5a623]" : "bg-transparent group-hover:bg-[#f5a623]/40",
                ].join(" ")}
              />
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  );
}
